import React from 'react';

const ProgressBar = ({ progress }) => {
  return (
    <div className='lead-card-man-progress-bar-out-pro'>
      <div
        className='lead-card-man-progress-bar-in-pro'
        style={{ width: `${progress}%` }}  // Dynamically set the width
      ></div>
    </div>
  );
};

export default ProgressBar;
